let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iv1W6")).then(() => parcelRequire('k090D'));